import React from 'react';
import Post from '../Post/Post';
import Classes from './BlogsList.module.css';

const CardList = props => {
  console.log('[CardList]', props, props.list[0]);
  const cardList = [...props.list];
  const blogs = (
    <div className={Classes.BlogsList}>
      {cardList.map(item => (
        <Post
          key={item.id}
          link={item.link}
          image={item.image}
          title={item.title}
        >
          {item.title}
        </Post>
      ))}
    </div>
  );

  return <div>{blogs}</div>;
};

export default CardList;
